import { render, staticRenderFns } from "./showGrid.vue?vue&type=template&id=0097bb70&scoped=true&"
import script from "./showGrid.vue?vue&type=script&lang=js&"
export * from "./showGrid.vue?vue&type=script&lang=js&"
import style0 from "./showGrid.vue?vue&type=style&index=0&id=0097bb70&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0097bb70",
  null
  
)

export default component.exports